import React from 'react';
import { PlainImage, ResponsiveImage } from "../imageComponents";
import RuleDescription from '../styledComponents/RuleDescription';

export const ImageMultilang = ({ ruleImage, rule, last, intl, imageSimple, imageRu, imageUk, imageEn}) => {
    return !ruleImage  
                ? <PlainImage 
                    src={intl.locale === 'ru' 
                            ? imageRu
                            : intl.locale === 'uk' 
                            ? imageUk 
                            : imageEn} 
                    last={last}
                    alt="" />
                : <>
                    <RuleDescription rule={rule} />
                    <PlainImage 
                    src={intl.locale === 'ru' 
                            ? imageRu
                            : intl.locale === 'uk' 
                            ? imageUk 
                            : imageEn} 
                        last={last} 
                        alt="" />
                </>
        }

export const ImageMultilangResp = ({ last, intl, imageRu, imageUk, imageEn, imageRuMob, imageUkMob, imageEnMob }) => {
    return <ResponsiveImage srcDesk={intl.locale === 'ru' 
                                    ? imageRu
                                    : intl.locale === 'uk' 
                                    ? imageUk 
                                    : imageEn}
                            srcMob={intl.locale === 'ru' 
                                    ? imageRuMob
                                    : intl.locale === 'uk' 
                                    ? imageUkMob
                                    : imageEnMob}
                            last={last} 
                            alt="" />
}